import Proj1 from "../assets/proj1.jpg";
import Proj2 from "../assets/proj2.jpg";
import Proj7 from "../assets/proj3.jpg";
import Proj4 from "../assets/proj4.jpg";
import Proj5 from "../assets/proj5.jpg";
import Proj6 from "../assets/proj6.png";

export const ProjectList = [
  {
    name: "My website",
    image: Proj1,
    skills: "JavaScript, React, HTML, CSS",
    githubUrl: "https://github.com/banigoden/denis_bandurin",
  },
  {
    name: "Automating CI/CD with GitHub Actions",
    image: Proj2,
    skills: "Github Actions, Terraform, Ansible, Docker",
    githubUrl: "https://github.com/banigoden/Python_Web_GitHub_Actions",
  },
  {
    name: "Pet clinic application",
    image: Proj7,
    skills: "Java, AWS, EC2, Maven, Docker, Docker Compose, Terraform",
    githubUrl:
      "https://github.com/banigoden/microservices-with-db-on-dev-server",
  },
  {
    name: "Jenkins-server via Terraform",
    image: Proj4,
    skills:
      "Jenkins, Terraform, Bash script, Docker, Git, AWS EC2, Route53, SecurityAccess",
    githubUrl: "https://github.com/banigoden/Jenkins-server",
  },
  {
    name: "My second website",
    image: Proj5,
    skills: "JavaScript,HTML,CSS",
    githubUrl: "https://github.com/banigoden/banigoden.io",
  },
  {
    name: "Djanco app + Ansible",
    image: Proj6,
    skills: "Python, Django, Ansible, PostgeSQL",
    githubUrl: "https://github.com/banigoden/django",
  },
];
